import type { TablePluginOptions } from '@atlaskit/editor-plugin-table';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';

export function tablePluginOptions(): TablePluginOptions {
	return {
		tableOptions: {
			allowTableResizing: true,
			allowTableAlignment: true,
			allowBackgroundColor: true,
			allowColumnResizing: true,
			allowColumnSorting: true,
			allowDistributeColumns: true,
			allowHeaderColumn: true,
			allowHeaderRow: true,
			allowMergeCells: true,
			allowNumberColumn: true,
			allowNestedTables: true,
			allowControls: true,
			stickyHeaders: true,
			allowAddColumnWithCustomStep: false,
		},
		dragAndDropEnabled: editorExperiment('platform_editor_tables_drag_and_drop', true),
		isTableScalingEnabled: true,
		allowContextualMenu: true,
		fullWidthEnabled: false,
		wasFullWidthEnabled: false,
		getEditorFeatureFlags: () => ({
			tableWithFixedColumnWidthsOption: true,

			tableSelector: editorExperiment('platform_editor_tables_table_selector', true),
		}),
		isCommentEditor: false,
		isChromelessEditor: false,
	};
}
